export { default } from './SWConfigureBundleOptions';
